import { render, staticRenderFns } from "./TableReturPembelian.vue?vue&type=template&id=b0c1b040"
import script from "./TableReturPembelian.vue?vue&type=script&lang=js"
export * from "./TableReturPembelian.vue?vue&type=script&lang=js"
import style0 from "./TableReturPembelian.vue?vue&type=style&index=0&id=b0c1b040&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports